import { isVisible } from './utils/utils';

export default function () {
    const dropdownPickers = document.querySelectorAll('.dropdown-picker');

    dropdownPickers.forEach(dp => {
        document.addEventListener('click', function (event) {
            const element = dp;

            if (!element.contains(event.target) && isVisible(element)) {
                element.classList.remove('show-dropdown');
            }
        });

        // kompaktowy przycisk: data-short na etykiecie ("18" zamiast "18 na stronie"),
        // data-placeholder na pickerze, gdy nic nie zaznaczone
        const selectedLabelItem = dp.querySelector('input[type="radio"]:checked + label');
        const selectedSpanText = selectedLabelItem
            ? selectedLabelItem.getAttribute('data-short') || selectedLabelItem.textContent
            : dp.getAttribute('data-placeholder') || '---';
        const selectedButton = dp.querySelector('.dropdown-button');

        selectedButton.textContent = selectedSpanText;

        selectedButton.addEventListener('click', function () {
            this.parentElement.classList.toggle('show-dropdown');
        });
    });
}